import { useQuery } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"
import { getCandidateProfile } from "../infrastructure/candidate-service"

export function useCandidateProfile(candidateId: string | null) {
  const organizationId = useSelector(selectCurrentOrganizationId)

  return useQuery({
    queryKey: ["candidate-profile", organizationId, candidateId],
    queryFn: () => getCandidateProfile(organizationId, candidateId!),
    enabled: !!organizationId && !!candidateId,
  })
}
